import { useState } from 'react'
import Dashboard from '../Dashboard'

// The admin shell. For this phase it's a thin wrapper around the existing
// <Dashboard> so admins keep the current experience byte-for-byte. It owns the
// `view` navigation state (moved out of App so the user side doesn't need it);
// later phases add Build/Evaluate tabs here.
export default function AdminConsole({ user = null, onLogout = () => {} }) {
  const [view, setView] = useState('dashboard') // 'dashboard' | 'agents' | 'build' | 'evaluate' | 'chat' | 'controls' | 'notifications' | 'approvals' | 'collections-*'
  // Some views (the Collections workspace) deep-link to a specific record; carry
  // that target alongside the view so <Dashboard> can hand it to the workspace.
  const [routeTarget, setRouteTarget] = useState({})
  const handleNavigate = (nextView, target = {}) => {
    setView(nextView)
    setRouteTarget(target)
  }
  return (
    <Dashboard view={view} onNavigate={handleNavigate} routeTarget={routeTarget} user={user} onLogout={onLogout} />
  )
}
